<div class="search-criteria">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="error">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li><button>{{errorMessage}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row search-selections">
        <div class="col-24">
            <h1 class="heading">My Clients </h1>
        </div>
        <div class="col-24">
            <hr />
        </div>
        <div class="row">
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" 
                                       [label]="'User Profile'"
                                       [disabled]=false
                                       [options]="userProfileDropdownValues"
                                       [selectedValue]="selectedUser"
                                       (onValueChange)="userProfileChanged($event)">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-18">
                <div class="input-wrapper">
                    &nbsp; <!-- empty column -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">&nbsp;</div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="input-wrapper">
                    <label>Application Start Date</label>
                    <JQDatePicker [selectedDate]="appStartDate"
                                  (elementClicked)="onInfoChange('ApplicationStartDate', $event)"></JQDatePicker>
                </div>
            </div>
            <div class="col-18">
                <div class="input-wrapper">
                    <label>Application End Date</label>
                    <JQDatePicker [selectedDate]="appEndDate"
                                  (elementClicked)="onInfoChange('ApplicationEndDate', $event)"></JQDatePicker>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button type="submit" id="getEnrollments" class="button primary next-to-field" (click)="onGetEnrollments()">Search</button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="countsVisible" >
        <div class="col-2">
            <a id="btnPrint" class="link-button link print" (click)="onPrint()">Print</a>
        </div>
        <div class="col-8">
            <button id="btnExport" class="button link excel" (click)="onExport()">Export to Excel</button>
        </div>
    </div>
    <div class="row" id="printArea"  *ngIf="countsVisible">
        <div class="col-24">
            <p>Click an underlined item to see more detail.</p>
            <jqxGrid #CountsGrid 
                     [width]="width"
                     [source]="dataAdapter"
                     [columns]="columns"
                     [autorowheight]="true"
                     [autoshowcolumnsmenubutton]="false"
                     [autoheight]="true"
                     [pageable]="true"
                     [pagesizeoptions]="[20, 50, 100]"
                     [pagesize]="50"
                     [sortable]="true"
                     [columnsresize]="true"
                     [selectionmode]="'multiplecellsadvanced'"
                     [showaggregates]="true"
                     (onPagesizechanged)="onPageSizeChanged($event)"
                     (onCellclick)="Cellclick($event)"
                     >
            </jqxGrid>
        </div>
    </div>
</div>
